import { render } from "./PerformanceChart2.vue?vue&type=template&id=2b99b028&ts=true"
import script from "./PerformanceChart2.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart2.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__